import icon1 from "../../assets/track_icons/icon1.webp";
import icon2 from "../../assets/track_icons/icon2.webp";
import icon3 from "../../assets/track_icons/icon3.webp";
import icon4 from "../../assets/track_icons/icon4.webp";
import icon5 from "../../assets/track_icons/icon5.webp";
import icon6 from "../../assets/track_icons/icon6.webp";
import icon7 from "../../assets/track_icons/icon7.webp";
import icon8 from "../../assets/track_icons/icon8.webp";
import icon9 from "../../assets/track_icons/icon9.webp";
import icon10 from "../../assets/track_icons/icon10.webp";
import icon11 from "../../assets/track_icons/icon11.webp";
import icon12 from "../../assets/track_icons/icon12.webp";
import icon13 from "../../assets/track_icons/icon13.webp";
import icon14 from "../../assets/track_icons/icon14.webp";
import icon15 from "../../assets/track_icons/icon15.webp";
import icon16 from "../../assets/track_icons/icon16.webp";
import icon17 from "../../assets/track_icons/icon17.webp";
import icon18 from "../../assets/track_icons/icon18.webp";
import icon19 from "../../assets/track_icons/icon19.webp";
import icon20 from "../../assets/track_icons/icon20.webp";
export const tracks = [
  { name: "AI/Machine Learning", icon: icon1 },
  { name: "Advanced Nanomaterials", icon: icon2 },
  { name: "Intelligent & Responsive Materials", icon: icon3 },
  { name: "Healthcare & Biomedicine", icon: icon4 },
  { name: "Nano-Sensors", icon: icon5 },
  { name: "Advanced Composites", icon: icon6 },
  { name: "Nano-Photonics", icon: icon7 },
  { name: "Nanoelectronics", icon: icon8 },
  { name: "Graphene Tech", icon: icon9 },
  { name: "Smart Sensors", icon: icon10 },
  { name: "Quantum Materials", icon: icon11 },
  { name: "Digital Manufacturing", icon: icon12 },
  { name: "Bio-Nanotechnology", icon: icon13 },
  { name: "2D Materials", icon: icon14 },
  { name: "Advanced Robotics & Automation", icon: icon15 },
  { name: "Thermoelectrics", icon: icon16 },
  { name: "Aerospace, Automotive & Defense", icon: icon17 },
  { name: "Laser & Plasma- Processing", icon: icon18 },
  { name: "Meta Materials", icon: icon19 },
  { name: "Nano Fibers", icon: icon20 },
];


